<template>
  <div class="max-w-5xl mx-auto">
    <div class=" my-10">
      <div class="bg-white overflow-hidden shadow rounded-lg mt-10">
        <div class="border-b border-gray-200 px-4 py-5 sm:px-6">
          <h1>Whatsapp Broadcast extension</h1>
        </div>
        <div class="px-4 py-5 sm:p-6">
          <div class="mt-2 mb-6 max-w-xl text-sm leading-5 text-gray-500">
            Broadcast your messages to your customers on your own whatsapp
            number.
          </div>
          <img src="../../assets/broadcastextn.png" />
        </div>
        <div
          class="bg-white shadow sm:rounded-lg"
          v-if="!shouldShowExtensionLink"
        >
          <div class="px-4 py-5 sm:p-6">
            <div class="sm:flex sm:items-start sm:justify-between">
              <div>
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  Upgrade to Advanced plan use this feature
                </h3>
                <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
                  <p></p>
                </div>
              </div>

              <div
                class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
              >
                <span class="inline-flex rounded-md shadow-sm">
                  <button
                    type="button"
                    class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
                    @click="gotoPlans"
                    v-if="store.plan !== 'advanced'"
                  >
                    Upgrade now
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="bg-white shadow sm:rounded-lg"
          v-if="shouldShowExtensionLink"
        >
          <div class="px-4 py-5 sm:p-6">
            <div class="sm:flex sm:items-start sm:justify-between">
              <div>
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  Download Chrome Extension
                </h3>
                <!-- <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Recusandae voluptatibus corrupti atque repudiandae nam.
              </p>
            </div> -->
              </div>

              <div
                class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
              >
                <span class="inline-flex rounded-md shadow-sm">
                  <button
                    type="button"
                    class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
                    @click="openDownload"
                  >
                    Add to chrome
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      browserPreference: "",
      isSaving: false,
      isSaved: false
    };
  },
  computed: {
    store() {
      return this.$store.getters.getStore;
    },
    shouldShowExtensionLink() {
      let result = false;
      const store = this.$store.getters.getStore;

      if (store && (store.plan === "advanced" || store.plan === "team")) {
        result = true;
      }

      return result;
    }
  },
  methods: {
    openDownload() {
      window.open(
        "https://chrome.google.com/webstore/detail/whatsapp-broadcast-carthi/odencepjbjkdkidibbigbgkeglchappo",
        "_blank"
      );
    },
    gotoPlans() {
      this.$router.push({ name: "Plan" });
    },
    saveBrowserPreference() {
      this.isSaving = true;
      this.$store
        .dispatch("updateConfig", {
          requestParams: {
            browserPreference: this.browserPreference
          }
        })
        .then(() => {
          this.isSaving = false;
          this.isSaved = true;
        });
    },
    joinWaitlist() {
      window.open(
        "https://web.whatsapp.com/send/?phone=+916374746603&text=I need chat crm",
        "_new"
      );
      this.$store
        .dispatch("joinWaitList", {
          requestParams: { feature: "chatExtension" }
        })
        .then(() => {
          this.isSaving = false;
          this.$store.dispatch("getConfig");
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
